import { ROLES } from '../../config/permissions-config';

export const PermissionRolesEnum = ROLES;
export type PermissionRolesEnum = typeof ROLES[keyof typeof ROLES];